 /*
   Connecting function with window, is good when it's something to do with html
   for ex: scroll to anchor element on page can be used in html directly without script
   <div onclick="window.scrollToAnchorUtil('anchor-id')">Scroll</div>
 */
 
 //scroll to anchor element on page
function scrollToAnchorUtil(anchor) {
    // wait until the target element exists
    const el = document.querySelector(anchor);
    console.log("el", el, anchor);
    if (el) {
      return el.scrollIntoView({ behavior: "smooth"});
  }
}

//scroll to anchor element on page load, when hash is given
function scrollToAnchorOnLoadUtil() {
    const hash = window.location.hash;
    if (hash) {
        return window.scrollToAnchorUtil(hash);
    }
}



function openCartDrawerUtil(){
    const drawer = document.querySelector('a[href="/cart"].Header__Icon');
          drawer.click();
    //fire custom event when drawer is opened
    const drawerOpenedEvent = new CustomEvent('drawerOpened');
    window.dispatchEvent(drawerOpenedEvent);
   
}

//@TODO - BADR: Add to cart with multiple items
function addToCartUtil(id, quantity, openCartDrawer = true) {
    if(!id || !quantity) return
    jQuery.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: { id, quantity },
        dataType: 'json',
        success: function (response) {

          // Cart refresh für Prestige Theme
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
            bubbles: true
          }));

         if(openCartDrawer) {
            openCartDrawerUtil();
         }
        },
        error: function (xhr, status, error) {
          console.error('Fehler beim Hinzufügen zum Warenkorb:', error);
        }
      });
}

/**
 * 
 * @param {HTMLButtonElement} button 
 * @param {*} callback 
 * @returns {void}
 */
function debounceButtonClickUtil(button, callback) {
    if (button.disabled) return;
    button.disabled = true;
    callback();
    setTimeout(() => {
        button.disabled = false;
    }, 500);
}